import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem('user') ? JSON.parse(localStorage.getItem("user")) : {
  user_name: "",
  email: "",
  user_image: "",
  isAuth: false,
  notificationCount: ''
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserLoginDetails: (state, action) => {
      state.user_name = action.payload.username;
      state.email = action.payload.email;
      // state.user_image = action.payload.image?.image;
      state.isAuth = action.payload.isAuth;
      state.notificationCount = action.payload.notificationCount
      localStorage.setItem("user", JSON.stringify(action.payload));
    },

    setSignOutState: (state) => {
      state.user_name = null;
      state.email = null;
      state.user_image = null;
      state.isAuth = false;
      state.notificationCount = false;
    },
  },
});

export const { setUserLoginDetails, setSignOutState } = userSlice.actions;

export const selectUserName = (state) => state.user.user_name;
export const selectUserEmail = (state) => state.user.email;
export const selectUseruserImage = (state) => state.user.user_image;

export default userSlice.reducer;
